import React, { useEffect, useState } from 'react'

const { app } = window;

// pour fonctionner correctement le gestionnaire d'évènements doit être
// vidé à chaque nouvelle page,
// ce qui est fait ici (avant été utilisé dans un will mount, ce qui n'existe plus)
export default function PageWrapper (Component)
{
	const PageWrapper = (props) =>
	{
		const [mounted, setMounted] = useState(false);

		useEffect(function ()
		{
			if (mounted) return;

			app.resetFunctions();

			setMounted(true);
		},
		[mounted]);

		if (!mounted) return null;

		const output =
		(
			<Component { ...props } />
		);

		return output;
	};

	return PageWrapper;
}